import {
  type AuthorizationParams,
  Auth0Provider as Provider
} from '@auth0/auth0-react'

import openIdConfig from './openIdConfig.json'
const env = process.env['REACT_APP_ENV'] ?? 'dev'

const { domain, clientId, issuer } =
  openIdConfig[env as keyof typeof openIdConfig]

const onRedirectCallback = (appState: any) => { }
const Auth0Provider = ({ children }: { children: any }) => {
  const { origin, pathname } = window.location
  const authorizationParams: AuthorizationParams = {
    redirect_uri: `${origin}${pathname}`,
    audience: "https://app.fdh.miraiz-connect.jp/"
  }
  return (
    <Provider
      domain={domain}
      clientId={clientId}
      issuer={issuer}
      authorizationParams={authorizationParams}
      cacheLocation='localstorage'
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}>
      {children}
    </Provider>
  )
}

export default Auth0Provider
